import React from "react";
import { getWeekNumber } from "../utils/snippets";
import ManagerCampaignView from "./ManagerCampaignView";

function ManagerCampaignList(props) {
  const {
    ads,
    tapes,
    campaign,
    setCampaign,
    search,
    setSearch,
    setBus,
    setTab,
  } = props;
  const curWeek = getWeekNumber(new Date());
  const [selectedWeek, setSelectedWeek] = React.useState(curWeek);
  let weekSelect = [];
  for (let i = 1; i < 53; i++) {
    weekSelect.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }
  weekSelect = (
    <div>
      <div className="week-select-title">
        <h3>Alkavat kampanjat viikolla </h3>
        <select
          value={selectedWeek}
          key={"weekSelect"}
          onChange={(event) => {
            setSelectedWeek(event.target.value);
          }}
        >
          {weekSelect}
        </select>
      </div>
      <input
        type={"text"}
        className={"search-field"}
        value={search.campaigns}
        placeholder={"Haku"}
        onChange={(event) => {
          setSearch({
            campaigns: event.target.value,
            buses: search.buses,
          });
        }}
      ></input>
    </div>
  );

  return (
    <div>
      {campaign ? (
        <ManagerCampaignView
          campaign={campaign}
          setCampaign={setCampaign}
          tapes={tapes}
          setBus={setBus}
          setTab={setTab}
        />
      ) : (
        <div>
          {weekSelect}
          <div>
            {ads
              .filter(
                (el) =>
                  !search.campaigns.length === 0 ||
                  String(el.client).search(RegExp(search.campaigns, "i")) !== -1
              )
              .reduce((pre, cur, index, array) => {
                if (Number(cur.start) === Number(selectedWeek)) {
                  const name = cur.format + " " + cur.client;
                  pre.push(
                    <div
                      className="campaign-item"
                      key={index}
                      onClick={() => {
                        setCampaign(cur);
                      }}
                    >
                      {name}
                    </div>
                  );
                }
                return pre;
              }, [])}
          </div>
        </div>
      )}
    </div>
  );
}

export default ManagerCampaignList;
